module.exports = __webpack_public_path__ + "static/media/iphone-frame.afb8acf3.png";